import { render, staticRenderFns } from "./GameItemsListSearch.vue?vue&type=template&id=0f3fab56&scoped=true&"
import script from "./GameItemsListSearch.vue?vue&type=script&lang=js&"
export * from "./GameItemsListSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3fab56",
  null
  
)

export default component.exports